import { Category } from '@models/category';
import { SlugEntityAdminApiService } from './slugEntityAdminApiService';
import { getLanguageByCode } from '@helpers/languages';
import { AdminCarouselItem } from '@models/section/cardCarouselSection';

export class CategoryAdminService extends SlugEntityAdminApiService<Category> {
    constructor() {
        super('/api/admin/category');
    }

    public getCarouselItems = async (languageCode: string): Promise<AdminCarouselItem[]> => {
        const languageId = getLanguageByCode(languageCode)?.id || 1;
        return (await this.getAll(languageId)).map((category) => ({
            content: category.name,
            value: category.id,
        }));
    };
}
